<template>
  <div>
    <img style="width: 140px; height: 40px" src="./static/inter_city_order/trip_logo.png" />
    <div class="">
      <div class="flex-center font-24 margin-y-15">云滴出行 —— 电子行程单</div>
      <div class="flex-between margin-bottom-10">
        <el-descriptions title="" :column="2" size="mini">
          <el-descriptions-item label="申请日期">{{ item.applyDate }}</el-descriptions-item>
          <el-descriptions-item label="行程时间"
            >{{ item.travelTimeStart }} 至 {{ item.travelTimeEnd }}</el-descriptions-item
          >
          <el-descriptions-item label="开票人手机号">{{ item.mobile }}</el-descriptions-item>
          <el-descriptions-item :label="`共${item.travelNumb}笔行程`"
            >{{ item.amountTotal }}元</el-descriptions-item
          >
        </el-descriptions>
      </div>
      <el-table :data="item.itineraryMsg" border size="mini" style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column prop="departTime" label="出发时间" width="180" align="center" />
        <el-table-column prop="startAdd" label="起点" width="180" align="center" />
        <el-table-column prop="endAdd" label="终点" align="center" />
        <el-table-column prop="passengerMsg" label="乘车人" align="center" />
        <el-table-column prop="payAmount" label="金额（元）" width="100" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    setup(props, context) {}
  }
</script>

<style lang="scss" scoped></style>
